import { render, staticRenderFns } from "./StarCompanyList.vue?vue&type=template&id=6552dbf9"
import script from "./StarCompanyList.vue?vue&type=script&lang=js"
export * from "./StarCompanyList.vue?vue&type=script&lang=js"
import style0 from "./StarCompanyList.vue?vue&type=style&index=0&id=6552dbf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports